<template>
  <div>
    <!-- SECCIÓN PRINCIPAL -->
    <transition name="fade">
      <div v-if="isVisible" class="fotoportada-container" ref="portadaRef">
        <img
          src="@/assets/foto_webp_maxima_calidad.webp"
          alt="Imagen de portada"
          class="fotoportada-img"
          ref="imagenPortada"
          loading="eager"
          decoding="async"
          fetchpriority="high"
        />

        <div class="overlay">
          <button class="hamburger" aria-label="Menú">
            <span></span><span></span><span></span>
          </button>

          <div class="texto-inferior" ref="textoInferiorRef">
            <h1 class="script-nombres">{{ nombresLinea }}</h1>
            <p class="script-fecha">{{ fechaLinea }}</p>
          </div>
        </div>

        <div class="footer-bar">
          <div class="footer-text"> EVELYN<br />LUIS</div>
          <div class="footer-menu"><i class="fas fa-bars"></i></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'PortadaBodaElegante',
  props: {
    nombresLinea: { type: String, default: 'Evelyn y Luis' },
    fechaLinea:   { type: String, default: '13 de diciembre de 2025' }
  },
  setup () {
    const isVisible = ref(true)

    const portadaRef = ref(null)
    const imagenPortada = ref(null)
    const textoInferiorRef = ref(null)

    const animarTexto = () => {
      if (!textoInferiorRef.value) return
      gsap.from(textoInferiorRef.value.children, {
        y: 22,
        opacity: 0,
        duration: 0.9,
        stagger: 0.12,
        ease: 'power3.out'
      })
    }

    onMounted(() => {
      // Animar texto al montar
      animarTexto()

      // Preload explícito de la portada
      nextTick(() => {
        if (imagenPortada.value?.src) {
          const preload = new Image()
          preload.src = imagenPortada.value.src
        }
      })
    })

    onBeforeUnmount(() => {
      // Limpiar animaciones del texto
      if (textoInferiorRef.value) gsap.killTweensOf(textoInferiorRef.value.children)
    })

    return {
      isVisible,
      portadaRef,
      imagenPortada,
      textoInferiorRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600&family=Great+Vibes&display=swap');

.fade-enter-active, .fade-leave-active { transition: opacity .3s ease; }
.fade-enter-from,  .fade-leave-to      { opacity: 0; }

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.fotoportada-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  will-change: auto;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 2;
}

.hamburger {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 22px;
  display: grid;
  gap: 5px;
  background: transparent;
  border: 0;
  padding: 0;
  z-index: 3;
}
.hamburger span {
  display: block;
  height: 2px;
  background: #fff;
  border-radius: 1px;
}

.texto-inferior {
  position: absolute;
  left: 0;
  right: 0;
  top: 95px;
  text-align: center;
  padding: 0 14px;
  z-index: 3;
}
.script-nombres {
  font-family: 'Great Vibes', cursive;
  font-size: 56px;
  line-height: 1.1;
  color: #fff;
  text-shadow: 0 2px 6px rgba(0,0,0,.35);
  font-weight: 400;
  letter-spacing: 1px;
  margin: 0 0 10px 0;
}
.script-fecha {
  font-family: 'Playfair Display', serif;
  font-size: clamp(18px, 3.6vw, 20px);
  letter-spacing: 2.5px;
  color: #fff;
  margin: 0;
  text-shadow: 0 2px 6px rgba(0,0,0,.35);
}

.footer-bar {
  position: absolute;
  bottom: -40px;
  width: 100%;
  height: 54px;
  background-color: rgba(161,151,142,.95);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: #fff;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 1px;
  z-index: 14;
}
.footer-text {
  line-height: 1.2;
  text-align: left;
}
.footer-menu {
  font-size: 18px;
}
</style>
